module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RatingCard/images/light.8e36288c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RatingCard/images/light.png
// module id = 3458
// module chunks = 11